import React from 'react'
import { DataTable } from '@shopify/polaris'
import './lappa-polaris-table-shell.sass'

/**
 * Polaris DataTable with Lappa settings table styling.
 * Columns/rows content is owned by the parent; this shell only applies visual shell.
 */
export default function LappaPolarisDataTableShell({
	rootClassName = 'LappaTable',
	tableClassName = '',
	shellClassName = '',
	isEmpty = false,
	columnContentTypes,
	headings,
	rows,
	emptyState = null,
	hideScrollIndicator = true,
	increasedTableDensity = false,
	hasZebraStripingOnData = false,
	verticalAlign = 'middle',
	...dataTableProps
}) {
	const tableClasses = [
		rootClassName,
		tableClassName,
		isEmpty ? `${rootClassName}--emptyInTableBody` : '',
	]
		.filter(Boolean)
		.join(' ')

	const shellClasses = [shellClassName].filter(Boolean).join(' ')

	return (
		<div className={shellClasses || undefined}>
			<div className={tableClasses}>
				<div className={`${rootClassName}__tableShell`}>
					<DataTable
						columnContentTypes={columnContentTypes}
						headings={headings}
						rows={isEmpty ? [] : rows}
						hideScrollIndicator={hideScrollIndicator}
						increasedTableDensity={increasedTableDensity}
						hasZebraStripingOnData={hasZebraStripingOnData}
						verticalAlign={verticalAlign}
						{...dataTableProps}
					/>
					{isEmpty && emptyState != null ? (
						<div
							className={`${rootClassName}__emptyInTableBody`}
							role='status'
							aria-live='polite'
						>
							{emptyState}
						</div>
					) : null}
				</div>
			</div>
		</div>
	)
}
